import React, { FC } from 'react'
import { cn } from 'shared/utils'
import { FormSlider } from 'components/Form'
import { useFormContext } from 'react-hook-form'

import { TableRowActionSliderProps } from './TableRowActionSlider.props'

import './TableRowActionsSlider.scss'

const TableRowActionsSlider: FC<TableRowActionSliderProps> = ({ fieldName, label, className }) => {
  const { control } = useFormContext()

  return (
    <FormSlider
      className={cn('table-row-actions-slider', className)}
      control={control}
      fieldName={fieldName}
      sliderLabel={label}
      label={''}
      colorTypeOff="info"
      colorTypeOn="secondary-black"
      size="xs"
    />
  )
}

export default TableRowActionsSlider
